import { useSelector } from 'react-redux';

import { getCurrentRut } from '~models/rut';

export const useRut = incumbent => {
  const { currentClient, currentGuarantor } = useSelector(state => state.simulation);
  const rutObject = getCurrentRut(currentClient, currentGuarantor);
  return rutObject[incumbent];
};
